/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


import BaseCookie from "@/core/js/Cookie/BaseCookie";
import {asBase64, fromBase64} from "@/utils/helpers";

export class SettingsCookie extends BaseCookie{

	constructor() {
		super('qwstn');
	}

	onBeforeSet(value){
		console.log("SettingsCookie: onBeforeSet: value = ", value)
		return asBase64(super.onBeforeSet(value))
	}

	onAfterGet(value){
		console.log("SettingsCookie: onAfterGet: value = ", value)
		return super.onAfterGet(fromBase64(value))
	}

}



